import React, { PropsWithChildren, forwardRef, useRef, useEffect, RefObject, HTMLAttributes } from 'react';

export default forwardRef((
  { events, children, ...props }: { events: Array<string> } & PropsWithChildren & HTMLAttributes<HTMLDivElement>,
  mainRef: RefObject<HTMLDivElement | null>
) => {
  if (!mainRef) {
    mainRef = useRef<HTMLDivElement | null>(null);
  }
  
  useEffect(() => {
    if (mainRef.current) {
      const stopHandler = (e: Event) => e.stopPropagation();
      for (let eventName of events) {
        mainRef.current.addEventListener(eventName, stopHandler);
      }
      return () => {
        if (mainRef.current) {
          for (let eventName of events) {
            mainRef.current.removeEventListener(eventName, stopHandler);
          }
        }
      }
    }
  }, [mainRef.current, events]);

  return (
    <div ref={mainRef} {...props}>
      {children}
    </div>
  );
});